import type { SVGProps } from 'react';

const SvgLongArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 67 19" {...props}>
    <path
      fill={props.color}
      d="m57.144 16.84 5.348-5.88H.972V8.44h61.52l-5.348-5.88L58.936.824 66.944 9.7l-8.008 8.876z"
    />
  </svg>
);

export default SvgLongArrowRight;
